import { useEffect, useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { Logo } from './Logo';
import { scrollToId } from '../lib/smoothScroll';

const links = [
  { label: 'Platform', id: 'platform' },
  { label: "Who It's For", id: 'who-its-for' },
  { label: 'Our Approach', id: 'approach' },
  { label: 'Integrations', id: 'integrations' },
  { label: 'About Us', id: 'about' },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled || open ? 'border-[#E5E7EB] bg-[#FAFAF7]/90 backdrop-blur-md' : 'border-transparent bg-transparent'
      }`}
    >
      <div className="container-relay flex h-[68px] items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          aria-label="AVENIR Relay — back to top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          <Logo small />
        </a>
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-[#374151] transition-colors duration-200 hover:text-[#0F5C4A]"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <button data-testid="nav-book-demo" onClick={() => go('enquiry')} className="btn-primary !px-5 !py-2.5">
            Book a Demo
          </button>
          <button data-testid="nav-contact" onClick={() => go('enquiry')} className="btn-secondary !px-5 !py-2.5">
            Contact Us
          </button>
        </div>
        <button
          data-testid="nav-mobile-toggle"
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#D1D5DB] bg-white lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-[#E5E7EB] bg-[#FAFAF7] px-5 pb-6 pt-2 lg:hidden" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full py-3 text-left text-base font-medium text-[#111111]"
            >
              {l.label}
            </button>
          ))}
          <div className="mt-3 flex flex-col gap-2.5">
            <button data-testid="nav-mobile-book-demo" onClick={() => go('enquiry')} className="btn-primary w-full">
              Book a Demo <ArrowRight size={15} />
            </button>
            <button data-testid="nav-mobile-contact" onClick={() => go('enquiry')} className="btn-secondary w-full">
              Contact Us
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
